<div class="container">
  <p>Select Time Frame</p>
  <mat-form-field>
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
      <input matStartDate formControlName="start" placeholder="Start date">
      <input matEndDate formControlName="end" placeholder="End date">
    </mat-date-range-input>
    <mat-hint>{{localeStr}}</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
    @if (range.controls.start.hasError('matStartDateInvalid')) {
      <mat-error>Invalid start date</mat-error>
    }
    @if (range.controls.end.hasError('matEndDateInvalid')) {
      <mat-error>Invalid end date</mat-error>
    }
  </mat-form-field>
  <div class="preset-container">
    <button class="lds-btn" (click)="addPresetTime('week-to-date')">Week to Date</button>
    <button class="lds-btn" (click)="addPresetTime('month-to-date')">Month to Date</button>
    <button class="lds-btn" (click)="addPresetTime('year-to-date')">Year to Date</button>
  </div>
  <div class="confirm-container">
    <button mat-dialog-close (click)="onCancel()" class="lds-btn" style="width: fit-content;">Cancel</button>
    <button mat-dialog-close cdkFocusInitial (click)="onConfirm()" class="lds-btn"  style="float: right; width: fit-content;">Confirm</button>
  </div>
</div>